import Tool, {
  simpleToolButton,
  type IToolActionInput,
  type IToolEnabledInput,
} from './Tool';
import { isEmbeddedBookmark } from '../objects/guards';

class ToolOpenView extends Tool {
  static toolName = 'Open view in new tab';

  static availableWhenLocked = true;

  static available({ selection, controller }: IToolEnabledInput): boolean {
    return (
      selection != null &&
      isEmbeddedBookmark(selection) &&
      controller.allowRecordLinking()
    );
  }

  static action({ selection }: IToolActionInput) {
    const object = selection.firstObject();

    if (object) {
      window.open(object.bookmarkUrl, '_blank');
    }
  }

  static enabled({ selection }: IToolEnabledInput) {
    return selection != null && isEmbeddedBookmark(selection);
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolOpenView,
      'fa-regular fa-arrow-up-right-from-square'
    );
  }
}

export default ToolOpenView;
